/* eslint-disable import/no-cycle */
import { RouteRecordRaw } from 'vue-router';;
import { ModelType } from '@llws/platform-shared-types/types/db/auth';
import { IRouteConfigAuthMeta, ERouteMetaPermissionMode } from '@/shared';

const psiPermission = {
  key: 'property_search',
  keyType: ModelType.account,
  mode: ERouteMetaPermissionMode.AT_LEAST_ONE,
};

const auth: IRouteConfigAuthMeta = {
  required: true,
  permissions: [{ keyType: ModelType.account, key: 'property_search' }, psiPermission ],
};

const psiAuth = {
  required: true,
  permissions: [psiPermission],
};

const propertySearchIndex: RouteRecordRaw = {
  path: '/websites/property-search',
  name: 'PropertySearchIndex',
  component: () => import('@/views/settings/property-search/Index.vue'),
  meta: {
    auth: psiAuth,
    title: 'Property Search',
    icon: 'cogs',
    active: false,
    noPagePadding: true,
    parent: null,
  },
};

const propertySearchFieldsBuilder: RouteRecordRaw = {
  path: '/websites/property-search/:psiId/fields-builder',
  name: 'PropertyFieldsBuilder',
  component: () => import('@/views/settings/property-search/templates/psi-builder/FieldsListingBuilder.vue'),
  meta: {
    auth: psiAuth,
    title: 'Fields Listing Builder',
    icon: 'cogs',
    active: false,
    noPagePadding: true,
    parent: propertySearchIndex,
    footerBar: {
      enabled: true,
      hasSave: true,
      extraButtons: {
        uuiKeyButton: {
          buttonText: () => '',
          buttonProps: {
            hollow: true,
            variant: 'secondary',
            class: 'd-none',
          },
        },
      },
    },
  },
};

const propertySearchFieldsMapBuilder: RouteRecordRaw = {
  path: '/websites/property-search/:psiId/fields-map-builder',
  name: 'PropertyFieldsMapBuilder',
  component: () => import('@/views/settings/property-search/templates/psi-builder/FieldsMapBuilder.vue'),
  meta: {
    auth: psiAuth,
    title: 'Fields Map Builder',
    icon: 'cogs',
    active: false,
    noPagePadding: true,
    parent: propertySearchIndex,
    footerBar: {
      enabled: true,
      hasSave: true,
      extraButtons: {
        uuiKeyButton: {
          buttonText: () => '',
          buttonProps: {
            hollow: true,
            variant: 'secondary',
            class: 'd-none',
          },
        },
      },
    },
  },
};

const propertySearchInstancesBuilder: RouteRecordRaw = {
  path: '/websites/property-search/:psiId/instances-builder',
  name: 'PropertySearchInstancesBuilder',
  component: () => import('@/views/settings/property-search/templates/psi-builder/InstancesBuilder.vue'),
  meta: {
    auth: psiAuth,
    title: 'Instances Builder',
    icon: 'cogs',
    active: false,
    noPagePadding: true,
    parent: propertySearchIndex,
    footerBar: {
      enabled: true,
      hasSave: true,
      extraButtons: {
        uuiKeyButton: {
          buttonText: () => '',
          buttonProps: {
            hollow: true,
            variant: 'secondary',
            class: 'd-none',
          },
        },
      },
    },
  },
};

const propertySearchDataFiltersBuilder: RouteRecordRaw = {
  path: '/websites/property-search/:psiId/data-filters-builder',
  name: 'DataFiltersBuilder',
  component: () => import('@/views/settings/property-search/templates/psi-builder/DataFiltersBuilder.vue'),
  meta: {
    auth: psiAuth,
    title: 'Data Filters Builder',
    icon: 'cogs',
    active: false,
    noPagePadding: true,
    parent: propertySearchIndex,
    footerBar: {
      enabled: true,
      hasSave: true,
      extraButtons: {
        uuiKeyButton: {
          buttonText: () => '',
          buttonProps: {
            hollow: true,
            variant: 'secondary',
            class: 'd-none',
          },
        },
      },
    },
  },
};

const propertySearchUiFiltersBuilder: RouteRecordRaw = {
  path: '/websites/property-search/:psiId/ui-filters-builder',
  name: 'UiFiltersBuilder',
  component: () => import('@/views/settings/property-search/templates/psi-builder/UiFiltersBuilder.vue'),
  meta: {
    auth: psiAuth,
    title: 'UI Filters Builder',
    icon: 'cogs',
    active: false,
    noPagePadding: true,
    parent: propertySearchIndex,
    footerBar: {
      enabled: true,
      hasSave: true,
      extraButtons: {
        uuiKeyButton: {
          buttonText: () => '',
          buttonProps: {
            hollow: true,
            variant: 'secondary',
            class: 'd-none',
          },
        },
      },
    },
  },
};

const propertySearchInstancesSort: RouteRecordRaw = {
  path: '/websites/property-search/:psiId/instances-sort',
  name: 'PropertyInstancesSort',
  component: () => import('@/views/settings/property-search/templates/psi-builder/InstancesSortsBuilder.vue'),
  meta: {
    auth: psiAuth,
    title: 'Instances Sort',
    icon: 'cogs',
    active: false,
    noPagePadding: true,
    parent: propertySearchIndex,
    footerBar: {
      enabled: true,
      hasSave: true,
      extraButtons: {
        uuiKeyButton: {
          buttonText: () => '',
          buttonProps: {
            hollow: true,
            variant: 'secondary',
            class: 'd-none',
          },
        },
      },
    },
  },
};

const propertySearchMapSettingsIndex: RouteRecordRaw = {
  path: '/websites/property-search/map-settings',
  name: 'MapSettingsIndex',
  component: () => import('@/views/settings/property-search/templates/map-settings/Index.vue'),
  meta: {
    auth: psiAuth,
    title: 'Map Settings',
    icon: 'map-marker-alt',
    active: false,
    noPagePadding: true,
    parent: propertySearchIndex,
  },
};

const propertySearchMapSettings: RouteRecordRaw = {
  path: '/websites/property-search/map-settings/:mapSettingId/edit',
  name: 'PropertyMapSettings',
  component: () => import('@/views/settings/property-search/templates/map-settings/MapSettings.vue'),
  meta: {
    auth: psiAuth,
    title: 'Map Settings',
    icon: 'map-marker-alt',
    active: false,
    noPagePadding: true,
    parent: propertySearchIndex,
    footerBar: {
      enabled: true,
      hasSave: true,
    },
  },
};

export default [
  propertySearchIndex,
  propertySearchFieldsBuilder,
  propertySearchFieldsMapBuilder,
  propertySearchInstancesBuilder,
  propertySearchDataFiltersBuilder,
  propertySearchUiFiltersBuilder,
  propertySearchInstancesSort,
  propertySearchMapSettingsIndex,
  propertySearchMapSettings,
] as Array<RouteRecordRaw>;
